import { createRoot } from 'react-dom/client';
import { Router } from './router';
import './index.css';
import { init } from '@sentry/react';

if (process.env.NODE_ENV === 'production') {
  const host = window.location.host;
  if (host !== 'app.keystonetutors.com' && host !== 'keystone-sandbox.pages.dev') {
    const url = new URL(window.location.href);
    url.host = 'app.keystonetutors.com';
    window.location.href = url.toString();
  }

  init({
    dsn: 'https://422370159d05fc27838ec8a3f6eae89e@o4509490938904576.ingest.de.sentry.io/4509491021938768',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  });
}

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(<Router />);
} else {
  throw new Error('Root element not found');
}
